import styled from "@emotion/styled";
import Page from "../../components/Page";
import Button from "../../components/Button";
import { optionState, sessionState, useAlert } from "../../../atom/common";
import Methods from "./Methods";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { providerState } from "../../../atom/simpleCert";
import { useEffect } from "react";
import { service_title } from "../../../constants/simple-cert";
import Tooltip from "../../components/Tooltip";

const Banner = styled.div`
    display: block;
    width: 100%;
    height: 100px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.background[1]};
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: fill; 
`;

const Text = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-size: 12px;
    text-align: center;
    margin-bottom: 16px;
    color: #595959;
`

export const PrivacyLink = styled.a`
    display: flex;
    justify-self: center;
    align-self: center;
    text-decoration: none;
    color: black;
`
export default function Home() {
    const resetProvider = useResetRecoilState(providerState)
    const alert = useAlert();
    const { service_code, hide_close_button } = useRecoilValue(optionState);
    const { banner } = useRecoilValue(sessionState);
    const { default_provider } = useRecoilValue(optionState);


    useEffect(() => {
        if (!default_provider) resetProvider();
    }, [resetProvider]);

    const title = `${service_title[service_code]} 서비스`;
    const description = (
        <>
            <span>인증서를 선택해 주세요</span>
        </>
    )

    const close = () => {
        alert("", "진행 중인 서비스를\n취소하시겠습니까?",
            () => {
                if (window.opener) window.close();
                else window.parent.postMessage({ code: "K0000", message: "성공", func: "close" }, "*");
            },
            () => { })
    };
    return (
        <Page>
            <Page.Header />
            {banner && <Banner> <Image src={banner} alt="" /> </Banner>}
            <Page.Content>
                <Page.Title title={title} description={description} />
                <Methods />
                <Text>개인정보는 인증기관별 개인정보처리방침에 따라 처리됩니다</Text>
                {!hide_close_button && <Button confirm={close}>닫기</Button>}
            </Page.Content>
        </Page>
    );
}

